import { createStore } from 'vuex'
import { get, post } from '@/api'
import { pushEndpoint, clearPushDevice } from '@/utils/push'
export default createStore({
  state: { user: null, manager: null, csrf: '', loaded: false, hasSeo: false },
  mutations: {
    setSession(state, data) { state.user = data.client || null; state.manager = data.manager || null; state.csrf = data.csrf || ''; state.loaded = true; state.hasSeo = data.hasSeo === true },
    clearUser(state) { state.user = null; state.manager = null; state.loaded = false; state.hasSeo = false }
  },
  actions: {
    async fetchUser({ commit }) {
      try { commit('setSession', await get('session')) }
      catch (error) { commit('clearUser'); throw error }
    },
    async login({ dispatch, state }, credentials) {
      await dispatch('fetchUser')
      await post('login', credentials, state.csrf)
      await dispatch('fetchUser')
    },
    async logout({ commit, state }) {
      const endpoint = await pushEndpoint().catch(() => '')
      await post('logout', { push_endpoint: endpoint }, state.csrf)
      await clearPushDevice().catch(() => {})
      commit('clearUser')
    }
  },
  getters: { user: state => state.user, authenticated: state => Boolean(state.user) }
})
